import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyChoVayApi from "service/quanLyThuChiApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import ReactToPrint from "react-to-print";
import userApi from "service/userApi";
import { Cookies } from "react-cookie";
import danhSachThongTinVayApi from "service/ChoThongTin/danhSachThongTinVayApi";
import thongBaoThongTinVayApi from "service/ChoThongTin/thongBaoThongTinVayApi";

export const ModalThongBaoKhiDangNhap = (props) => {
  const scrollRef = useRef();
  const [isRoleChoTinDung, setRoleChoTinDung] = useState(false);
  const cookies = new Cookies();
  useEffect(() => {
    userApi.getCurrentUser().then((response) => {
      if (typeof response.data.CompanyID !== "undefined") {
        danhSachThongTinVayApi.checkRoleChoTinDung().then((res) => {
          // Neu tai khoan chu hien thi thong bao va cho vao link cho tindung
          if (
            typeof res.data.IsRoleChoTinDung === "undefined" ||
            res.data.IsRoleChoTinDung == true
          ) {
            setRoleChoTinDung(true);
          } else {
            // Neu khong tai khoan chu
            thongBaoThongTinVayApi
              .checkQuyenHienThi(response.data.CompanyID)
              .then((responseDetail) => {
                if (responseDetail.data == "1") {
                  setRoleChoTinDung(true);
                } else if (responseDetail.data == "0") {
                  setRoleChoTinDung(false);
                }
              });
          }
        });
      }
    });
  }, []);
  const urlChoTinDung = () => {
    // window.location.href = "cho-thong-tin/danh-sach-vay.aspx";
    props.onHide();
    userApi.getCurrentUser().then((response) => {
      if (typeof response.data.CompanyID !== "undefined") {
        thongBaoThongTinVayApi
          .checkQuyenHienThi(response.data.CompanyID)
          .then((responseDetail) => {
            if (responseDetail.status === 200) {
              if (responseDetail.data != "1") {
                window.open(
                  window.urlChoTinDung +
                  "cho-thong-tin/Dang-Ky-Tai-Khoan.aspx",
                  "_blank"
                );
              } else if (responseDetail.data == "0") {
                window.open(
                  window.urlChoTinDung + "cho-thong-tin/danh-sach-vay.aspx",
                  "_blank"
                );
              }
            }
          });
      }
    });

    // window.open("cho-thong-tin/danh-sach-vay.aspx", "_blank");
  };
  const urlError = () => {
    window.location.href = "/trang-chu/Page-Error.aspx";
  };

  return (
    <Modal
      {...props}
      size="modal-dialog modalNewTT"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail "
      backdrop="static"
    >
      <Modal.Body>
        <div style={{ textAlign: "center" }}>
          <div class="icon-box">
            <i class="mdi mdi-checkbox-marked-circle-outline"></i>
          </div>
          <h4>
            Bạn đã nhận được <span style={{ color: "#c0392b" }}>500 data</span>{" "}
            mới!
          </h4>
          <p>Đã có 500 data khách vay mới trên Chợ thông tin tín dụng.</p> 
          <p>
            <a
              className="btn btn-new-main btn-closenew"
              data-dismiss="modal"
              href={() => false}
              target="_blank"
              onClick={isRoleChoTinDung ? urlChoTinDung : urlError}
            >
              Xem ngay !
            </a>
            <a
              className="btn btn-new-main btn-closenew ml-3"
              data-dismiss="modal"
              href={() => false}
              onClick={props.onHide}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-close"></i>
              </span>
              Đóng
            </a>
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};
